import LogoutIcon from "@mui/icons-material/Logout";
import FolderIcon from "@mui/icons-material/Folder";
import LockIcon from "@mui/icons-material/Lock";

export type CustomMenuItem = {
  items?: CustomMenuItem[];
  text: string;
  path?: string;
  icon?: React.ElementType;
  startsWithDivider?: boolean;
};

export const sidebarMainMenuItems: CustomMenuItem[] = [
  {
    text: "Projects",
    path: "/projects",
    icon: FolderIcon,
  },
  {
    text: "Globals Secrets",
    path: "/globals-secrets",
    icon: LockIcon,
  },
];

export const sidebarBottomMenuItems: CustomMenuItem[] = [
  {
    text: "Esci",
    icon: LogoutIcon,
  },
];

// For backward compatibility
export const sidebarMenuItems: CustomMenuItem[] = [
  ...sidebarMainMenuItems,
  {
    startsWithDivider: true,
    ...sidebarBottomMenuItems[0],
  },
];
